const LombaRobotKeren: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <h2 className="text-lg font-semibold mb-3">🚀 Kenapa Ikut Lomba Robotik Itu Keren?</h2>

            <p className="mb-4">
                Lomba robotik bukan sekadar kompetisi untuk jadi juara. Ia adalah pengalaman belajar yang menyeluruh—menggabungkan ilmu pengetahuan, seni, kreativitas, strategi, dan kerja sama tim dalam satu wadah. Dari tantangan teknis hingga euforia saat robot berhasil bergerak sesuai rencana, semua jadi momen yang tak terlupakan.
            </p>

            <h3 className="text-md font-semibold mb-2">💡 Manfaat Besar dari Ikut Lomba Robotik</h3>

            <ul className="list-disc list-inside space-y-4 mb-6">
                <li>
                    <strong>🎨 Mengasah kreativitas dan kemampuan problem solving</strong><br />
                    Saat mengikuti lomba, kamu tidak akan diberi solusi. Justru kamu ditantang untuk menciptakan solusi sendiri. Mulai dari bagaimana membuat robot melewati rintangan, hingga bagaimana menyusun algoritma agar robot bisa menyelesaikan misi secepat mungkin. Semua mengasah daya pikir kritis dan imajinasi teknologimu.
                </li>

                <li>
                    <strong>🔧 Menerapkan teori jadi kenyataan</strong><br />
                    Pernah bertanya-tanya, “Fungsi trigonometri ini buat apa?” atau “Logika if-else gunanya apa sih?” Di lomba robotik, kamu akan melihat sendiri bagaimana rumus-rumus yang kamu pelajari di sekolah ternyata bisa dipakai untuk navigasi, pemetaan jarak, hingga mengatur kecepatan motor. Ilmu jadi terasa hidup dan menyenangkan!
                </li>

                <li>
                    <strong>🤝 Melatih kerja tim dan manajemen proyek</strong><br />
                    Dalam lomba robotik, tidak semua bisa dikerjakan sendiri. Ada yang mendesain struktur, ada yang fokus pada pemrograman, ada yang merancang strategi. Kunci keberhasilan terletak pada komunikasi yang baik, kolaborasi yang efektif, dan pembagian tugas yang jelas. Ini jadi latihan awal untuk dunia kerja nyata yang juga sangat kolaboratif.
                </li>

                <li>
                    <strong>🎓 Membuka pintu ke dunia teknik dan inovasi</strong><br />
                    Pengalaman ikut lomba robotik bisa menjadi nilai tambah saat kamu melanjutkan pendidikan atau mencari pekerjaan di bidang teknik, mekatronika, AI, hingga industri otomasi. Banyak universitas dan perusahaan menghargai pengalaman praktikal seperti ini karena menunjukkan inisiatif, kreativitas, dan kemampuan bekerja di bawah tekanan.
                </li>

                <li>
                    <strong>🏆 Membangun rasa percaya diri dan jiwa kompetitif sehat</strong><br />
                    Menyiapkan robot dari nol, mengatasi masalah teknis di lapangan, dan akhirnya melihat robotmu tampil di arena lomba adalah proses yang membangun mental kuat dan rasa percaya diri. Bahkan kalau tidak menang sekalipun, pengalaman dan pembelajaran yang kamu dapat tetap sangat berharga.
                </li>
            </ul>

            <p className="text-gray-700">
                Intinya, lomba robotik adalah wadah seru untuk mengeksplorasi teknologi, bekerja sama dengan teman-teman, dan menemukan potensi diri yang mungkin belum kamu sadari. Siap jadi calon inovator masa depan? Dunia sedang menunggumu! 🔧🤖🔥
            </p>

        </div>
    )
}
export default LombaRobotKeren